"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoDataFound = NoDataFound;

var _react = _interopRequireWildcard(require("react"));

require("../dist/no-data-found.css");

function NoDataFound(_ref) {
  var NoDataImage = _ref.NoDataImage,
      alt = _ref.alt,
      NoDataTitle = _ref.NoDataTitle,
      NoDataDesc = _ref.NoDataDesc;
  return _react.default.createElement("div", {
    className: "no-data-found-wrapper"
  }, _react.default.createElement("div", {
    className: "no-data-found-img"
  }, _react.default.createElement("img", {
    className: "nodata-img",
    src: NoDataImage,
    alt: alt
  })), _react.default.createElement("div", {
    className: "no-data-found-content"
  }, _react.default.createElement("h2", null, NoDataTitle), _react.default.createElement("p", null, NoDataDesc)));
}

;